export default __webpack_public_path__ + "static/media/tresOpen.745c86a4.jpg";